module.exports = __webpack_public_path__ + "static/media/download.433f865c.svg";